import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Field, propTypes as formPropTypes } from 'redux-form';
import { debouncedReduxForm } from 'sharedParts';

import QuestionErrorMessage from '../../QuestionErrorMessage';
import CommentsField from '../../../CommentsField';
import MatrixTableField from '../../matrix/matrixTable/taker/MatrixTableField';
import withMatrixMetric from '../../hoc/withMatrixMetric';
import withMatrixRowValidator from '../../hoc/withMatrixRowValidator';
import isQuestionCommentsDisabled from '../../../../utils/isQuestionCommentsDisabled';
import propTypeBlockStyling from '../../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

import styles from './MatrixQuestionForm.scss';

class MatrixQuestionForm extends Component {
  static propTypes = {
    cancelSubmit: PropTypes.func.isRequired,
    flushSubmit: PropTypes.func.isRequired,
    inputRowField: PropTypes.func.isRequired,
    hasInvalidRowForm: PropTypes.bool,
    styling: propTypeBlockStyling,
    ...formPropTypes,
  };

  componentWillUnmount() {
    this.props.cancelSubmit();
  }

  render() {
    const {
      block,
      block: { commentsEnabled, commentsLabel },
      formErrorMessage,
      hasInvalidRowForm,
      inputRowField,
      styling,
      flushSubmit,
    } = this.props;

    return (
      <div>
        <QuestionErrorMessage
          fieldMeta={{
            submitFailed: hasInvalidRowForm,
            invalid: hasInvalidRowForm,
            error: formErrorMessage,
          }}
        />
        <Field
          name="value"
          format={null}
          component={MatrixTableField}
          props={{
            hasInvalidRowForm,
            block,
            inputRowField,
            styling,
          }}
        />
        <Field
          name="comments"
          component={CommentsField}
          onBlur={flushSubmit}
          props={{
            className: styles.comments,
            disabled: isQuestionCommentsDisabled(this.props),
            commentsEnabled,
            commentsLabel,
            styling,
          }}
        />
      </div>
    );
  }
}

export default compose(
  withMatrixMetric,
  withMatrixRowValidator,
  debouncedReduxForm({
    isAutoSubmit: true,
    form: 'MatrixQuestionForm',
  }),
)(MatrixQuestionForm);
